<template>
  <div class="plan_item">
    <div class="plan_item_advertisement">
      <!-- <img :src="banner" /> -->
      <!-- <img src="https://www.7859888tp.com/750-50.gif" /> -->
    </div>
    <p class="plan_item_title">
      <span>平特六不中</span>
    </p>
    <ul>
      <li v-for="(el, i) in data.list" :key="i">
        <span class="qi">
          <span>{{ el.qiShu }}期</span>
          <span>免费大公开</span>
          <span style="color: #ff0000; background: #ffff00; font-size: 50px">
            《平特六不中》
          </span>
        </span>
        <div class="naoji">中奖很简单，牢记本网址</div>
        <div class="yuce">
          <div :class="{ suck: !el.ifWin && !el.ifZuiXin }">
            <div class="value">
              【
              <span
                v-for="(num, numIndex) in el.ifZuiXin
                  ? JSON.parse(el.yuCe)
                  : el.yuCe"
                :key="numIndex"
              >
                <span :class="{ win: num.ifWin }">{{ num.yuCe || num }}, </span>
              </span>
              】
              <span class="winText" v-if="el.ifZuiXin">等待开奖</span>
              <span v-else :style="{ color: el.ifWin ? '#facc03' : '#000' }">
                {{ el.ifWin ? "准" : "错" }}</span
              >
            </div>
          </div>
        </div>
        <div v-if="!el.ifZuiXin">
          <span class="winText">
            开奖：
            <span
              v-for="num in el.codeList"
              :style="{ background: el.yuCe.includes(num) ? '#78bb7b' : '' }"
            >
              {{ num }} ,
            </span>
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>
      
<script setup>
import top from "@/assets/img/top.gif";
import { toRefs } from "vue";
import { getNumSx } from "@/utils";

const props = defineProps({
  data: Object,
});

const { data } = toRefs(props);
</script>
      
<style lang="scss" scoped>
.plan_item {
  border: 1px solid #009788;
  .plan_item_advertisement {
    img {
      width: 100%;
      height: 40px;
      display: block;
    }
  }
  .plan_item_title {
    text-align: center;
    color: #fff;
    background-image: linear-gradient(to bottom, #787275, #edebec) !important;
    padding: 3px 0;
    border-top: 2px solid #767474;
    border-bottom: 2px solid #767474;
    img {
      display: inline-block;
      width: 30px;
      height: 30px;
    }
  }
  ul {
    background-color: #fff;
    li {
      text-align: center;
      &:not(:last-child) {
        border-bottom: 2px solid #fff;
      }
      .yuce {
        color: #6914e3;
        text-align: center;
        padding: 5px 12px;
        font-weight: bold;
        display: flex;
        justify-content: center;
        .name {
          color: #6914e3;
        }
        .value {
          color: red;
          .win {
            background-color: #ffff00;
          }
        }
      }
    }
    .li_win {
      .winText {
        color: #309631;
      }
    }
  }
}
</style>